// @flow
import React from 'react';
import {
  compose,
  setDisplayName,
} from 'recompose';
import Badge, { Kind } from '@ux/badge';
import { FormattedMessage } from 'react-intl';

const PureDomainAdIcon = ({
  theme,
}) => (
  <Badge
    theme={theme}
    kind={Kind.SECONDARY}
  >
    <span
      style={{
        // didn't think it warranted an entire stylesheet
        color: theme.palette.primary,
      }}
    >
      <FormattedMessage id="dst.standardDomains.ad"/>
    </span>
  </Badge>
);

export const enhance = compose(
  setDisplayName('DomainAdIcon'),
);

export default enhance(PureDomainAdIcon);
